import Level from "./Level";
import Rain from "./Rain";
import Temperature from "./Temperature";

class WeatherData {
    name: string;
    currentRain: number;
    humidity: number;
    riverLevel: number;
    temperature: number;
    temperatureFeel: number;
    windSpeed: number;
    windDirection: number;
    airPressure: number;
    riverLevelHistory: Level[];
    rainVolumes: Rain[];
    temperatureHistory: Temperature[];
    loaded: boolean = false;

    constructor(name: string, currentRain: number, humidity: number, riverLevel: number, temperature: number, temperatureFeel: number, windSpeed: number, windDirection: number, airPressure: number, loaded: boolean) {
        this.name = name;
        this.currentRain = currentRain;
        this.humidity = humidity;
        this.riverLevel = riverLevel;
        this.temperature = temperature;
        this.temperatureFeel = temperatureFeel;
        this.windSpeed = windSpeed;
        this.windDirection = windDirection;
        this.airPressure = airPressure;
        this.riverLevelHistory = [];
        this.rainVolumes = [];
        this.temperatureHistory = [];
        this.loaded = loaded;
    }

    setRiverLevels(levels: Level[]) {
        this.riverLevelHistory = levels;
    }

    getRiverLevels() {
        return this.riverLevelHistory;
    }

    setRainVolumes(volumes: Rain[]) {
        this.rainVolumes = volumes;
    }

    getRainVolumes() : Rain[] {
        return this.rainVolumes;
    }

    getName(): string {
        return this.name;
    }

    getCurrentRain(): number {
        return this.currentRain;
    }

    getHumidity(): number {
        return this.humidity;
    }

    getRiverLevel(): number {
        // some places have the current level totally off, but historic levels are correct
        // to handle it we check if the current level is above 3x last historical level, if it does we use historical data        
        if (this.riverLevelHistory?.length > 0 && 
            this.riverLevel >= this.riverLevelHistory[this.riverLevelHistory.length - 1].getLevel() * 3) {
                return this.riverLevelHistory[this.riverLevelHistory.length - 1].getLevel();
            }
        return this.riverLevel;
    }

    getTemperature(): number {
        return this.temperature;
    }

    getTemperatureFeel(): number {
        return this.temperatureFeel;
    }
    
    getWindSpeed(): number {
        return this.windSpeed;
    }

    getWindDirection(): number {
        return this.windDirection;
    }

    getAirPressure(): number {
        return this.airPressure;
    }

    setTemperatureHistory(history: Temperature[]) {
        this.temperatureHistory = history;
    }

    getTemperatureHistory() {
        return this.temperatureHistory;
    }

    getLevelDifference(): number|null {
        if (this.riverLevelHistory && this.riverLevelHistory.length > 1) {
            const previousLevel = this.riverLevelHistory[this.riverLevelHistory.length - 2].getLevel();
            if (typeof previousLevel != 'number') {
                return null;
            }
            return this.riverLevel - this.riverLevelHistory[this.riverLevelHistory.length - 2].getLevel();
        }
        return null;
    }

    isLoaded(): boolean {
        return this.loaded;
    }
}

export default WeatherData;
